module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('meta', {
    attrs: {
      "charset": "utf-8"
    }
  }), _vm._v(" "), _c('link', {
    attrs: {
      "href": "styles/default.css",
      "rel": "stylesheet",
      "type": "text/css"
    }
  }), _vm._v(" "), _c('title', [_vm._v("5 Minutes With Jesus: Quiet Time for Your Soul")]), _vm._v(" "), _c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "A_q"
    }
  }, [_c('div', {
    staticClass: "image1"
  }, [_c('img', {
    attrs: {
      "alt": "images/himg-6-1.jpg",
      "src": "images/himg-6-1.jpg"
    }
  })]), _vm._v(" "), _c('h1', {
    staticClass: "chapter",
    attrs: {
      "id": "pz14-2"
    }
  }, [_c('b', [_c('a', {
    attrs: {
      "href": "#/contents#ba_08",
      "id": "ab_08"
    }
  }, [_vm._v("How He Longs for You")])])]), _vm._v(" "), _c('p', {
    staticClass: "noind",
    attrs: {
      "id": "pAfoM"
    }
  }, [_c('span', {
    staticClass: "dcap"
  }, [_vm._v("I")]), _vm._v("t is truly one of the most heartbreaking moments in all of Scripture.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "pz14-4"
    }
  }, [_vm._v("In Matthew 23:37, we see Jesus’ heart for Israel, His wandering people: “Jerusalem, Jerusalem, you who kill the prophets and stone those sent to you, how often I have longed to gather your children together, as a hen gathers her chicks under her wings, and you were not willing.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "pz14-5"
    }
  }, [_vm._v("Jesus spoke these words to the Jews, but His divine words tell us a lot about the heart of God for all His people. Our heavenly Father longs for relationship with His children. He longs to protect them, to be near them, to hold them close to His heart.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "pz14-6"
    }
  }, [_vm._v("Maybe you find that thought surprising, but we can find a lot of evidence in Scripture that God desires an intimate relationship with us. Way back in the garden, before God banished Adam and Eve from Eden, He made a promise that He would find a way to bring His children back home.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "pz15-1"
    }
  }, [_vm._v("It would take centuries for that rescue story to play out. Battles would be waged and kingdoms would rise and fall, all as part of that rescue plan, all leading up to the birth of the Messiah.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "pz15-2"
    }
  }, [_vm._v("And when that Messiah came, He loved to tell stories about God’s longing heart. Jesus compared God and His lost children to a woman who searched for her precious lost coin, and to a shepherd who was so desperate to find one wayward sheep that he left all the other sheep to search for it and bring it home (Luke 15:1–10).")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "pz15-3"
    }
  }, [_vm._v("Finally, Jesus said, God’s longing for His lost children was like a father who had lost his son, a father who would never give up and who would give absolutely anything to have his boy come home (vv. 11–32).")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "pz15-4"
    }
  }, [_vm._v("What about you? Have you wandered far away from home? Or perhaps you just need to hear your Father say those sweet words one more time:")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "pz15-5"
    }
  }, [_vm._v("“Oh, how I long to gather you near . . .”")]), _vm._v(" "), _c('div', {
    staticClass: "box",
    attrs: {
      "id": "pz15-6"
    }
  }, [_c('p', {
    staticClass: "center1"
  }, [_c('b', [_c('i', [_vm._v("You don’t have to clean yourself up to come home to your Father. Just come.")])])])]), _vm._v(" "), _c('p', {
    staticClass: "center2",
    attrs: {
      "id": "pz16-1"
    }
  }, [_c('img', {
    attrs: {
      "alt": "images/himg-8-1.jpg",
      "src": "images/himg-8-1.jpg"
    }
  }), _vm._v(" "), _c('b', [_vm._v("Five Minutes in the Word")]), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "images/himg-8-2.jpg",
      "src": "images/himg-8-2.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center",
    attrs: {
      "id": "pAby"
    }
  }, [_c('i', [_vm._v("“ ‘My son,’ the father said, ‘you are always with me, and everything I have is yours. But we had to celebrate and be glad, because this brother of yours was dead and is alive again; he was lost and is found.’ ”")])]), _vm._v(" "), _c('p', {
    staticClass: "center3",
    attrs: {
      "id": "AgX1"
    }
  }, [_vm._v("Luke 15:31–32")]), _vm._v(" "), _c('p', {
    staticClass: "center",
    attrs: {
      "id": "A0z"
    }
  }, [_c('i', [_vm._v("“I tell you that in the same way there will be more rejoicing in heaven over one sinner who repents than over ninety-nine righteous persons who do not need to repent.”")])]), _vm._v(" "), _c('p', {
    staticClass: "center3",
    attrs: {
      "id": "Agj"
    }
  }, [_vm._v("Luke 15:7")]), _vm._v(" "), _c('p', {
    staticClass: "center",
    attrs: {
      "id": "AMc"
    }
  }, [_c('i', [_vm._v("“The Son of Man came to seek and to save the lost.”")])]), _vm._v(" "), _c('p', {
    staticClass: "center3",
    attrs: {
      "id": "A75"
    }
  }, [_vm._v("Luke 19:10")]), _vm._v(" "), _c('p', {
    staticClass: "center",
    attrs: {
      "id": "AyU"
    }
  }, [_c('i', [_vm._v("“I have swept away your offenses like a cloud, your sins like the morning mist. Return to me, for I have redeemed you.”")])]), _vm._v(" "), _c('p', {
    staticClass: "center3",
    attrs: {
      "id": "APF"
    }
  }, [_vm._v("Isaiah 44:22")]), _vm._v(" "), _c('p', {
    staticClass: "center",
    attrs: {
      "id": "ASBH"
    }
  }, [_c('i', [_vm._v("“My sheep listen to my voice; I know them, and they follow me. I give them eternal life, and they shall never perish; no one will snatch them out of my hand.”")])]), _vm._v(" "), _c('p', {
    staticClass: "center3",
    attrs: {
      "id": "AHY"
    }
  }, [_vm._v("John 10:27–28")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b7572964","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chapter08.vue
// module id = 78
// module chunks = 0